export class ErrorService {
    public static log = (error: any) => {
        console.error(`FOUNDAT_WEB_ERROR: `, error);
    };
}